export const chainRPCEndpoints = [
  {
    name: `shiden`,
    // endpointURL: `https://shiden.blastapi.io/8f90e266-fd9a-4284-9365-cec6112934d2`,
    endpointURL: `https://shiden.stmnode.com/`,
    chainId: `336`,
  },
  {
    name: `astar`,
    // endpointURL:`https://astar.blastapi.io/2701976f-e4e6-4004-b961-523c8f844957`,
    // endpointURL: `https://astar.blastapi.io/fa48f86b-06b2-4162-a0e4-1d3c80b04ee3`,
    // endpointURL: `https://astarnode.sushitop.io`,
    endpointURL: `https://astar.stmnode.com`,
    chainId: `592`,
  },
  {
    name: `polygon`,
    endpointURL: `https://polygon-mainnet.infura.io/v3/4d20e55995f54fabb320dec99707071b`,
    chainId: `137`,
  },
  {
    name: `oasys`,
    endpointURL: `https://rpc.chainverse.info`,
    chainId: `5555`,
  },
];